(() => {
  if (window.formthrCursorFloatLoaded) return;
  window.formthrCursorFloatLoaded = true;
  const enabled = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  const selector = 'body.index .formulas-showcase__card--product';
  let activeCard = null;
  function reset() {
    if (!activeCard) return;
    activeCard.style.removeProperty('--formthr-cursor-x');
    activeCard.style.removeProperty('--formthr-cursor-y');
    activeCard = null;
  }
  document.addEventListener('pointermove', (event) => {
    if (!enabled.matches || event.pointerType === 'touch') return;
    const card = event.target.closest(selector);
    if (card !== activeCard) reset();
    if (!card) return;
    activeCard = card;
    const rect = card.getBoundingClientRect();
    const x = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
    const y = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
    card.style.setProperty('--formthr-cursor-x', `${(x * 8).toFixed(2)}px`);
    card.style.setProperty('--formthr-cursor-y', `${(y * 5).toFixed(2)}px`);
  }, { passive: true });
  document.addEventListener('pointerout', (event) => {
    if (activeCard && (!event.relatedTarget || !activeCard.contains(event.relatedTarget))) reset();
  }, { passive: true });
  window.addEventListener('blur', reset);
  enabled.addEventListener('change', reset);
  document.addEventListener('shopify:section:unload', reset);
})();
